import { render, staticRenderFns } from "./PaymentsView.vue?vue&type=template&id=9ed78af4&scoped=true"
import script from "./PaymentsView.vue?vue&type=script&lang=js"
export * from "./PaymentsView.vue?vue&type=script&lang=js"
import style0 from "./PaymentsView.vue?vue&type=style&index=0&id=9ed78af4&prod&lang=scss"
import style1 from "./PaymentsView.vue?vue&type=style&index=1&id=9ed78af4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ed78af4",
  null
  
)

export default component.exports